import styles from './add-new-version-dialog.module.scss';
import { useContext, useState } from 'react';
import { v4 } from 'uuid';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, PrimaryButton, SnackBarContext, TextField } from '@frontend-workspace/react-shared-lib';
import { useTranslation } from 'react-i18next';
import { useMakeRequestHook } from '../../requestUtils';

/* eslint-disable-next-line */
export interface AddNewVersionDialogProps {
  open: boolean,
  onClose: () => void,
  getData: () => void,
  relationProductId: string
}

export function AddNewVersionDialog(props: AddNewVersionDialogProps) {
  const { t } = useTranslation();
  const makeRequest = useMakeRequestHook();
  const [versionName, setVersionName] = useState<string>('');
  const { setSnackbarMessage } = useContext(SnackBarContext);

  const handleVersionNameChange = (event: any) => setVersionName(event.target.value);

  const handleNewVersion = () => {
    makeRequest(`relationProducts/${props.relationProductId}/versions/`, 'PUT', {
      name: versionName,
      id: v4()
    }).then(result => {
      setSnackbarMessage({ content: t("addNewVersion.newVersionCreated"), type: 'success' });
      props.getData();
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t("addNewVersion.couldNotCreateNewVersion"), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth="md">
      <DialogTitle className='mb-4'>
        {t("standard.newVersion")}
      </DialogTitle>
      <DialogContent>
        <div className='mb-3'>
          <TextField
            fullWidth
            label={t("addNewVersion.selectName")}
            name='versionName'
            value={versionName}
            onChange={handleVersionNameChange}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          variant="contained"
          size='large'
          onClick={handleNewVersion}
          className='minButtonWidth'>
          OK
        </PrimaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default AddNewVersionDialog;